// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-1b036412] .c7{font-style:normal;font-weight:400}[data-v-1b036412] .c4,[data-v-1b036412] .c5{page-break-after:avoid}[data-v-1b036412] .c1{font-weight:400}[data-v-1b036412] .c1,[data-v-1b036412] .c11{font-style:normal}[data-v-1b036412] .c10{font-weight:700}[data-v-1b036412] .c2{margin-left:36pt}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
